import React from "react";
import DashBoards from "./DashBoards";

const SchoolDashboard = () => <DashBoards />;

export default SchoolDashboard;